import "./DetailPanel.css"
import {Icon} from "@material-ui/core";

export const DetailPanel = ({children, icon, title, id}) => {
	return (
		<div className="container" id={id}>
			<Icon>{icon}</Icon>
			<h1>{title}</h1>
			<div className="detail">{children}</div>
		</div>
	)
}